import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ApiErrorService } from './services/interceptors/api-error.interceptor';
import { authInterceptor } from './services/interceptors/auth.interceptor';


export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), // ✅ Correct
    provideRouter(routes), // ✅ Register router with routes
    // { provide: RouteReuseStrategy, useClass: CustomReuseStrategy }, // ✅ Custom RouteReuseStrategy
    importProvidersFrom(MatDatepickerModule, MatNativeDateModule),
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    provideAnimationsAsync(), // ✅ Async Animations
    provideHttpClient(withInterceptors([ApiErrorService])), // ✅ HttpClient with Interceptors
    provideHttpClient(withInterceptors([authInterceptor])),
    provideCharts(withDefaultRegisterables()), // ✅ Charts with defaults
  
  ],
};
